var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDerrick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39787 2.79643L3.08811 6H3C2.44772 6 2 6.44772 2 7V8C2 8.55228 2.44772 9 3 9H7V12.5566L10.8212 10.3505C10.8787 10.3173 10.9388 10.2925 11 10.2759V9H17V11.5C17 12.0552 17.3016 12.54 17.75 12.7993V16H17C16.4477 16 16 16.4477 16 17V18C16 18.5523 16.4477 19 17 19H20C20.5523 19 21 18.5523 21 18V17C21 16.4477 20.5523 16 20 16H19.25V12.7993C19.6984 12.54 20 12.0552 20 11.5V9H21C21.5523 9 22 8.55228 22 8V7C22 6.44772 21.5523 6 21 6H14.9119L10.6021 2.79643C9.62198 2.06786 8.37802 2.06786 7.39787 2.79643ZM9.75 4.03203L12.3975 6H9.75V4.03203ZM8.25 6H5.60249L8.25 4.03203V6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22C5 21.4477 5.44772 21 6 21H7V19.2887L11 16.9793V21H12C12.5523 21 13 21.4477 13 22C13 22.5523 12.5523 23 12 23H6C5.44772 23 5 22.5523 5 22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20C16.4477 20 16 20.4477 16 21V22C16 22.5523 16.4477 23 17 23H20C20.5523 23 21 22.5523 21 22V21C21 20.4477 20.5523 20 20 20H17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.9793V15.2759C10.9388 15.2925 10.8787 15.3173 10.8212 15.3505L7 17.5566V14.2887L11 11.9793Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerrick);
export default __webpack_public_path__ + "static/media/derrick.0dc21209e8ce5f4057d221354a2c2b8d.svg";
export { ForwardRef as ReactComponent };